export const labelStyle = {fontSize: '0.8rem', fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'}